import Groups from '../api/Groups';
import Users from '../api/Users';

/**
 * 
 * @param {int} userId - the user associated with the groups (for their profile, checkin, POS reference, whatever) 
 * @param {bool} adminOverride - if true 
 * @param {array of ints} familyIds - if the ids are already known, they can be passed in, otherwise the function will get them
 * @param {array of objects} familyGroups - if the group data is already known, it can be passed in and the function will make sure everything is formatted in a predictable way
 * @param {string} memberFilter - how to filter the members.  Can do "all", "noDupes", "byGroups", "authOnly" - most are what they sound like, auth only is also "no dupes"
 */
export const getFamilyMembers = async (userId, memberFilter="noDupes", adminOverride = false, familyIds=[], familyGroups=[])=>{
    let allMembers = []
    let byGroup = []

    if(!familyGroups?.length){
        let allIds = []
        if(!familyIds?.length) allIds = await getFamilyGroups(userId); 
        else allIds = familyIds; 
        familyGroups = await Promise.all(allIds.map(async(groupId)=>{
            let eachFamilyMembers = await handleEachFamily(userId, groupId, adminOverride);
            byGroup.push({group_id: groupId, members: eachFamilyMembers, auth_user: userId});
            allMembers.push(...eachFamilyMembers);
        }))
    }else if(familyGroups?.length){
        familyGroups.forEach((group)=>{
            let eachFamilyMembers = handleGroupMembers(userId, group, adminOverride);
            byGroup.push({group_id: group.id, members: eachFamilyMembers, auth_user: userId});
            allMembers.push(...eachFamilyMembers);
        })
    }
    let byUnique = makeUnique(allMembers);
    let authOnly = byUnique.filter((member)=>member.authIsAdmin === 1 || member.authIsAdmin === true);
    if(memberFilter === "noDupes") return byUnique;
    else if(memberFilter === "authOnly") return authOnly;
    else if(memberFilter === "byGroups") return byGroup;
    else if(memberFilter === "all") return allMembers;
}


/**
 * 
 * @param {int} userId - The user that needs family groups looked up 
 */
export const getFamilyGroups = async (userId)=>{
    let familyGroupIds = [];
    try{
        let response = await Users.groups({id: userId});
        if(!response.errors && response.status === 200){
            familyGroupIds = response?.data?.map((group)=>group.group_id)
        }
    }catch(ex){
        console.error(ex)
    }finally{
        return familyGroupIds;
    }
}

/**
 * 
 * @param {int} userId - if on someone's profile or profile or in reference to a user
 * @param {int} family  - the id of family to look up
 * @param {bool} adminOverride 
 */
export const handleEachFamily = async(userId, family, adminOverride=false)=>{
    let returnedMembers = [];
    try{
        let response = await Groups.get({id: family})
        if(!response.errors && response.status === 200){
            let groupData = response.data[0];
            returnedMembers = handleGroupMembers(userId, groupData, adminOverride)
        }
    }catch(ex){
        console.error(ex)
    }
    finally{
        return returnedMembers;
    }
}

export const handleGroupMembers=async(userId, groupData, adminOverride=false)=>{
    let returnedMembers = [];
    let isAdmin = adminOverride;
    if(!adminOverride){
        let memberRole = groupData?.group_members?.find(member=>member?.user_id === userId)?.group_member_role_id;
        isAdmin = groupData?.group_member_roles?.find(role => role.id === memberRole).is_admin;
    }
    groupData?.group_members?.forEach((member)=>{
        //depending on where the data comes from, a family may have "user_id" or "id"
        if(!member.hasOwnProperty("user_id")) member.user_id = member.id;
        else if(member.hasOwnProperty("user_id") && !member.hasOwnProperty("id")) member.id = member.user_id;     
        if(member.group_member_status_id === 2 && member.user_id !== userId){
            member.authChecked = userId;
            member.authIsAdmin = isAdmin;
            returnedMembers.push(member)
        }
    })
    return returnedMembers;
}

/**
 * @param {array} array - array of objects to be made unique
 * 
 * Utility function for saving family - reduces the JSON family to a string to determine uniqueness and then convert it back
 */
export const makeUnique=(array)=>{
    let stringObj=array.map((eachMember)=>JSON.stringify(eachMember));
    let objectSet=new Set(stringObj);
    let uniqueArray = Array.from(objectSet)
    return uniqueArray.map((eachString)=>JSON.parse(eachString))
}
